import {Condition} from '@ucast/core';
import {UserStatus} from '../entity';

export const DEFAULT_PAGE_SIZE = 25;
export const DEFUALT_PAGE_INDEX = 0;
export const DEFAULT_SORT_BY_FIELD = 'createdAt';
export const DEFAULT_ORDER: SortDirection = 'desc';

export const DEFAULT_PAGE_EVENT: IPageEvent = {
    pageIndex: DEFUALT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    length: 0,
};

export const DEFAULT_SORT: ISort = {
    active: DEFAULT_SORT_BY_FIELD,
    direction: DEFAULT_ORDER,
};

export const DEFUALT_SEARCH: IPagedSearch = {
    sort: DEFAULT_SORT,
    page: DEFAULT_PAGE_EVENT,
};

export function getDefaultpage<T>(): IPagedData<T> {
    return {
        data: [],
        page: DEFAULT_PAGE_EVENT,
        sort: DEFAULT_SORT,
    };
}

export const DEFUALT_PAGE_DATA = {
    data: [],
    page: DEFAULT_PAGE_EVENT,
    sort: DEFAULT_SORT,
};

export function sort(values: Record<string, any>): ISort {
    const x = {
        active: values['active'] || DEFAULT_SORT_BY_FIELD,
        direction: values['direction'] || DEFAULT_ORDER,
    };
    return x;
}

export function page(values: Record<string, object>): IPageEvent {
    const x = {
        pageIndex: +values['pageIndex'] || DEFUALT_PAGE_INDEX,
        pageSize: +values['pageSize'] || DEFAULT_PAGE_SIZE,
        length: 0,
    };
    return x;
}

export function pageEvent<T>(values: Record<string, object>): IPagedData<T> {
    return {data: [], sort: sort(values), page: page(values)};
}

export interface IAccessTokenResponse {
    accessToken: string;
    refreshToken: string;
    status: UserStatus;
}

export interface TableStatus {
    state: 'loading' | 'error' | 'success' | 'search';
    message?: string;
}

export interface IPagedSearch {
    sort: ISort;
    page: IPageEvent;
    condition?: Condition;
    projection?: string;
}

export interface ISearch {
    condition: Condition;
    projection?: string;
}

export interface IPageEvent {
    pageIndex: number;
    previousPageIndex?: number;
    pageSize: number;
    length: number;
}

export interface IFileUploaded {
    url: string;
}

export declare type SortDirection = 'asc' | 'desc' | '';

export interface ISort {
    /** The id of the column being sorted. */
    active: string;

    /** The sort direction. */
    direction: SortDirection;
}

export interface IPagedData<T = unknown[]> {
    data: T[];
    page: IPageEvent;
    sort: ISort;
}

export function asc(name: string): ISort {
    return {
        active: name,
        direction: 'asc',
    };
}

export function desc(name: string): ISort {
    return {
        active: name,
        direction: 'desc',
    };
}
